import React, { useEffect, useState } from 'react';
import '../../assets/landingPageCss/common.css';
import '../../assets/landingPageCss/style.css';
import '../../assets/landingPageCss/features.css';
import Navbar from './Navbar';
import Footer from './Footer';
import LottiePlayer from './LottiePlayer';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';

function Features() {
  document.title = 'Adcropper | Features';

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [designState, setDesignState] = useState(false);
  const [animateState, setAnimateState] = useState(false);
  const [automateState, setAutomateState] = useState(false);
  const [collaborateState, setCollaborateState] = useState(false);
  const [deliverState, setDeliverState] = useState(false);
  const [measureState, setMeasureState] = useState(false);

  return (
    <main className='untitled-page mainContent'>
      <Navbar />
      <section className='featureSection'>
        <div class="featureWrapper">
          <h1 class="featureTitle">
            Smart and Stunning Ads<br />
            <span class="underline">in a Moment</span>
          </h1>
          <p class="featureText">Simplify every step of ad production and delivery process with Adcropper Platform.
            Design, animate, automate, and deliver ads faster than ever.</p>
          <a href="#feature" class="featureButton" >HOW IT WORKS</a>
        </div>
      </section>
      {/* Feature List Section */}
      <section class="featureListSection" id="feature">

        <div class="featureListRow">
          <div class="featureList">
            <div class="featureListImageCont">
              {/* <lottie-player class="designWithEase featureListImage" id="designWithEase" src="assets/lotties/designWithEase.json"></lottie-player> */}
              <LottiePlayer
                className={'designWithEase featureListImage'}
                id={'designWithEase'}
                src={'./landing/designWithEase.json'}
                visibility={[0, 1.0]}
                frames={[0, 150]}
                actions={[{
                  visibility: [0, 0.1],
                  type: "stop",
                  frames: [0]
                },
                {
                  visibility: [0.1, 0.9],
                  type: "loop",
                  frames: [0, 150]
                },
                {
                  visibility: [0.9, 1],
                  type: "seek",
                  frames: [150]
                  // frames: [0, 150]
                },
                ]}
              />
            </div>
            <h2 class="featureListTitle">Design With Ease</h2>
            <p class="featureListText">Adcropper Platform simplifies the design process by offering a vast library of pre-built, ready-to-use templates customised for various ad formats, including display ads, social media ads, and CRM banners. Here's how it makes the process easier:</p>
            <button className='featureButton featureReadMoreBtn' onClick={() => setDesignState(true)}>Learn More</button>
          </div>

          <div class="featureList">
            <div class="featureListImageCont">
              {/* <lottie-player class="creatingWebsite featureListImage" id="creatingWebsite" src="assets/lotties/creatingWebsite.json"></lottie-player> */}
              <LottiePlayer
                className={'creatingWebsite featureListImage'}
                id='creatingWebsite'
                src={'./landing/creatingWebsite.json'}
                visibility={[0, 1.0]}
                frames={[0, 150]}
                actions={[{
                  visibility: [0, 0.1],
                  type: "stop",
                  frames: [0]
                },
                {
                  visibility: [0.1, 0.9],
                  type: "loop",
                  frames: [0, 150]
                },
                {
                  visibility: [0.9, 1],
                  type: "seek",
                  frames: [150]
                  // frames: [0, 150]
                },
                ]}
              />
            </div>
            <h2 class="featureListTitle">Animate With Style</h2>
            <p class="featureListText">Adcropper Platform makes creating stylish animations effortless by integrating with Figma and offering powerful features designed for ease and creativity. Here's how it simplifies the animation process:
            </p>
            <button className='featureButton featureReadMoreBtn' onClick={() => setAnimateState(true)}>Learn More</button>
          </div>
        </div>

        <div class="featureListRow">
          <div class="featureList">
            <div class="featureListImageCont">
              {/* <lottie-player class="automate featureListImage" id="automate" src="assets/lotties/automate.json"></lottie-player> */}
              <LottiePlayer
                className={'automate featureListImage'}
                id={'automate'}
                src={'./landing/automate.json'}
                visibility={[0, 1.0]}
                frames={[0, 150]}
                actions={[{
                  visibility: [0, 0.1],
                  type: "stop",
                  frames: [0]
                },
                {
                  visibility: [0.1, 0.9],
                  type: "loop",
                  frames: [0, 150]
                },
                {
                  visibility: [0.9, 1],
                  type: "seek",
                  frames: [150]
                  // frames: [0, 150]
                },
                ]}
              />
            </div>
            <h2 class="featureListTitle">Automate Instantly</h2>
            <p class="featureListText">Adcropper Platform speeds up the process of creating and launching visual ads and PPC (Pay-Per-Click) campaigns through several key features:</p>
            <button className='featureButton featureReadMoreBtn' onClick={() => setAutomateState(true)}>Learn More</button>
          </div>

          <div class="featureList">
            <div class="featureListImageCont">
              {/* <lottie-player class="collaborate featureListImage" id="collaborate" src="assets/lotties/collaborate.json"></lottie-player> */}
              <LottiePlayer
                className={'collaborate featureListImage'}
                id={'collaborate'}
                src={'./landing/collaborate.json'}
                visibility={[0, 1.0]}
                frames={[0, 150]}
                actions={[{
                  visibility: [0, 0.1],
                  type: "stop",
                  frames: [0]
                },
                {
                  visibility: [0.1, 0.9],
                  type: "loop",
                  frames: [0, 150]
                },
                {
                  visibility: [0.9, 1],
                  type: "seek",
                  frames: [150]
                  // frames: [0, 150]
                },
                ]}
              />
            </div>
            <h2 class="featureListTitle">Collaborate as a Team</h2>
            <p class="featureListText">Adcropper Platform makes team collaboration seamless by providing a centralised platform for design drafts, feedback, and approvals. Here's how it enhances collaboration:</p>
            <button className='featureButton featureReadMoreBtn' onClick={() => setCollaborateState(true)}>Learn More</button>
          </div>
        </div>

        <div class="featureListRow">
          <div class="featureList">
            <div class="featureListImageCont">
              {/* <lottie-player class="deliver featureListImage" id="deliver" src="assets/lotties/deliver.json"></lottie-player> */}
              <LottiePlayer
                className={'deliver featureListImage'}
                id={'deliver'}
                src={'./landing/deliver.json'}
                visibility={[0, 1.0]}
                frames={[0, 150]}
                actions={[{
                  visibility: [0, 0.1],
                  type: "stop",
                  frames: [0]
                },
                {
                  visibility: [0.1, 0.9],
                  type: "loop",
                  frames: [0, 150]
                },
                {
                  visibility: [0.9, 1],
                  type: "seek",
                  frames: [150]
                  // frames: [0, 150]
                },
                ]}
              />
            </div>
            <h2 class="featureListTitle">Deliver with a Click</h2>
            <p class="featureListText">Adcropper Platform’s integrations with major ad servers and programmatic platforms make publishing ads quick and easy. Here's how these integrations help streamline the process:
            </p>
            <button className='featureButton featureReadMoreBtn' onClick={() => setDeliverState(true)}>Learn More</button>
          </div>
          <div class="featureList">
            <div class="featureListImageCont">
              {/* <lottie-player class="measure featureListImage" id="measure" src="assets/lotties/measure.json"></lottie-player> */}
              <LottiePlayer
                className={'measure featureListImage'}
                id={'measure'}
                src={'./landing/measure.json'}
                visibility={[0, 1.0]}
                frames={[0, 150]}
                actions={[{
                  visibility: [0, 0.1],
                  type: "stop",
                  frames: [0]
                },
                {
                  visibility: [0.1, 0.9],
                  type: "loop",
                  frames: [0, 150]
                },
                {
                  visibility: [0.9, 1],
                  type: "seek",
                  frames: [150]
                  // frames: [0, 150]
                },
                ]}
              />
            </div>
            <h2 class="featureListTitle">Measure to Improve</h2>
            <p class="featureListText">Adcropper’s built-in analytics tools empower you to track and improve your ad campaigns by providing detailed insights into performance. Here's how it helps:
            </p>
            <button className='featureButton featureReadMoreBtn' onClick={() => setMeasureState(true)}>Learn More</button>
          </div>
        </div>
      </section>
      <Footer />

      {/* Design */}
      <Modal isOpen={designState} toggle={() => setDesignState(false)}>
        <ModalHeader className='p-3' toggle={() => setDesignState(false)}>
          <p style={{ font: '700 35px/1.1 Poppins,Helvetica,Arial,serif', color: 'white', margin: '0px' }}>Design With Ease</p>
        </ModalHeader>
        <ModalBody>
          <p className='featureListText text-align-left' style={{ font: '400 14px/1.33 Roboto,Helvetica,Arial,serif', color: '#030344' }}>Time-Saving Templates: Instead of designing from scratch, users can choose from a wide selection of professionally crafted templates. These templates are optimised for different platforms and can be customised quickly, significantly reducing the design time.</p>
          <br />
          <p className='featureListText text-align-left' style={{ font: '400 14px/1.33 Roboto,Helvetica,Arial,serif', color: '#030344' }}>Intuitive Editing Tools: With easy-to-use drag-and-drop functionality, even non-designers can tweak and personalise the templates to fit their brand's look and feel. No advanced design skills are required, making it accessible to all users.</p>
          <br />
          <p className='featureListText text-align-left' style={{ font: '400 14px/1.33 Roboto,Helvetica,Arial,serif', color: '#030344' }}>Platform-Ready Designs: Each template is designed with platform-specific dimensions and best practices in mind, ensuring your ads look great on any channel—whether it’s Google Display, Facebook, or CRM.</p>
          <br />
          <p className='featureListText text-align-left' style={{ font: '400 14px/1.33 Roboto,Helvetica,Arial,serif', color: '#030344' }}>Creative Inspiration: The variety of templates help users get inspired and find designs that match their campaign goals, ensuring high-quality visuals without the stress of brainstorming from scratch.</p>
          <br />
          <p className='featureListText text-align-left' style={{ font: '400 14px/1.33 Roboto,Helvetica,Arial,serif', color: '#030344' }}>By offering these streamlined tools and pre-designed options, Adcropper removes much of the hassle from ad creation, enabling users to focus more on strategy and less on the technicalities of design.</p>
        </ModalBody>
      </Modal>

      {/* Animate */}
      <Modal isOpen={animateState} toggle={() => setAnimateState(false)}>
        <ModalHeader className='p-3' toggle={() => setAnimateState(false)}>
          <p style={{ font: '700 35px/1.1 Poppins,Helvetica,Arial,serif', color: 'white', margin: '0px' }}>
            Animate With Style
          </p>
        </ModalHeader>
        <ModalBody>
          <p class="featureListText text-align-left" style={{ font: '400 14px/1.33 Roboto,Helvetica,Arial,serif', color: '#030344' }}>Figma Plugin Integration: Adcropper Platform’s Figma plugin allows users to animate their static banners directly within the design tool they are already familiar with. This seamless integration eliminates the need for external animation software, streamlining the workflow.
          </p>
          <br />
          <p class="featureListText text-align-left" style={{ font: '400 14px/1.33 Roboto,Helvetica,Arial,serif', color: '#030344' }}>Predefined Animations: Users can choose from hundreds of professional and predefined animation styles. Whether it’s subtle fades or dynamic motion effects, Adcropper Platform offers a wide range of stylish options designed to capture attention and make ads more engaging.
          </p>
          <br />
          <p class="featureListText text-align-left" style={{ font: '400 14px/1.33 Roboto,Helvetica,Arial,serif', color: '#030344' }}>Batch Editing: Adcropper Platform enables users to apply animations to multiple ad formats in one go. This saves significant time, as you don’t have to individually animate each banner—just select the preferred animation and apply it across all necessary formats instantly.
          </p>
          <br />
          <p class="featureListText text-align-left" style={{ font: '400 14px/1.33 Roboto,Helvetica,Arial,serif', color: '#030344' }}>Duplication and Scalability: Once animated, users can easily duplicate ads for various sizes, platforms, or languages without needing to reanimate them. This feature ensures that the animated ads maintain a consistent look and feel across different campaigns.
          </p>
          <br />
          <p class="featureListText text-align-left" style={{ font: '400 14px/1.33 Roboto,Helvetica,Arial,serif', color: '#030344' }}>By providing these user-friendly tools and a broad selection of stylish animations, Adcropper allows users to quickly bring their static banners to life, resulting in visually stunning ads that stand out.
          </p>
        </ModalBody>
      </Modal>

      {/* Automate */}
      <Modal isOpen={automateState} toggle={() => setAutomateState(false)}>
        <ModalHeader className='p-3' toggle={() => setAutomateState(false)}>
          <p style={{ font: '700 35px/1.1 Poppins,Helvetica,Arial,serif', color: 'white', margin: '0px' }}>
            Automate Instantly
          </p>
        </ModalHeader>
        <ModalBody>
          <p class="featureListText text-align-left" style={{ font: '400 14px/1.33 Roboto,Helvetica,Arial,serif', color: '#030344' }}>User-Friendly Interface: The Platform’s intuitive interface simplifies ad creation, even for users without deep technical expertise. Pre-built templates and drag-and-drop tools allow you to design ads quickly, reducing the complexity of starting from scratch.
          </p>
          <br />
          <p class="featureListText text-align-left" style={{ font: '400 14px/1.33 Roboto,Helvetica,Arial,serif', color: '#030344' }}>Automation Tools: Adcropper automates repetitive tasks such as keyword selection, audience targeting, and bid optimization, ensuring that the campaigns are configured with best practices in mind. This automation significantly reduces the time required to set up campaigns manually.
          </p>
          <br />
          <p class="featureListText text-align-left" style={{ font: '400 14px/1.33 Roboto,Helvetica,Arial,serif', color: '#030344' }}>Instant Publishing: The platform integrates with major ad networks (like Google Ads, Facebook Ads, etc.), allowing you to publish ads directly from the dashboard. This seamless integration means you don’t have to switch between different platforms, streamlining the entire workflow.
          </p>
          <br />
          <p class="featureListText text-align-left" style={{ font: '400 14px/1.33 Roboto,Helvetica,Arial,serif', color: '#030344' }}>Real-Time Analytics: Adcropper Platform offers real-time performance insights, enabling rapid adjustments and optimization of live campaigns without waiting for traditional reporting delays. This immediate feedback loop ensures campaigns are refined faster and more effectively.
          </p>
          <br />
          <p class="featureListText text-align-left" style={{ font: '400 14px/1.33 Roboto,Helvetica,Arial,serif', color: '#030344' }}>By eliminating manual work, offering smart automation, and enabling faster iteration, Adcropper helps businesses reduce the time to launch for ads and maintain a competitive edge in the fast-paced world of digital advertising.
          </p>
        </ModalBody>
      </Modal>

      {/* Collaborate */}
      <Modal isOpen={collaborateState} toggle={() => setCollaborateState(false)}>
        <ModalHeader className='p-3' toggle={() => setCollaborateState(false)}>
          <p style={{ font: '700 35px/1.1 Poppins,Helvetica,Arial,serif', color: 'white', margin: '0px' }}>
            Collaborate as a Team
          </p>
        </ModalHeader>
        <ModalBody>
          <p class="featureListText text-align-left" style={{ font: '400 14px/1.33 Roboto,Helvetica,Arial,serif', color: '#030344' }}>Centralized Dashboard: Adcropper Platform lets you directly share design drafts instead of coping with multiple tools. All team members can access the same dashboard, eliminating the need to switch between apps or tools.
          </p>
          <br />
          <p class="featureListText text-align-left" style={{ font: '400 14px/1.33 Roboto,Helvetica,Arial,serif', color: '#030344' }}>Real-Time Feedback: Colleagues can leave comments and suggestions directly on the designs, enabling immediate feedback. This feature helps streamline discussions, as all feedback is stored in one place, reducing miscommunication and confusion.
          </p>
          <br />
          <p class="featureListText text-align-left" style={{ font: '400 14px/1.33 Roboto,Helvetica,Arial,serif', color: '#030344' }}>Easy Revisions: Team members can easily track revisions and updates. Designers can quickly implement changes based on the feedback without needing to revisit previous emails or Slack threads to clarify what needs to be adjusted.
          </p>
          <br />
          <p class="featureListText text-align-left" style={{ font: '400 14px/1.33 Roboto,Helvetica,Arial,serif', color: '#030344' }}>Streamlined Approvals: The Platform simplifies the approval process by allowing stakeholders to approve or request changes in a single click. This eliminates the slow, back-and-forth communication typically required for approvals, speeding up the entire workflow.
          </p>
          <br />
          <p class="featureListText text-align-left" style={{ font: '400 14px/1.33 Roboto,Helvetica,Arial,serif', color: '#030344' }}>Version Control: Adcropper Platform enables teams to track and manage changes to advertising campaigns and creatives. It allows for easy viewing and turning back to previous versions, ensuring smooth collaboration and reducing the risk of errors. This feature helps maintain consistency and control over campaign modifications within the team. 
          </p>
          <br />
          <p class="featureListText text-align-left" style={{ font: '400 14px/1.33 Roboto,Helvetica,Arial,serif', color: '#030344' }}>By consolidating feedback, revisions, and approvals in one space, Adcropper Platform helps teams collaborate efficiently, cutting down on time wasted in endless email chains or scattered messages across various platforms.
          </p>
        </ModalBody>
      </Modal>

      {/* Deliver */}
      <Modal isOpen={deliverState} toggle={() => setDeliverState(false)}>
        <ModalHeader className='p-3' toggle={() => setDeliverState(false)}>
          <p style={{ font: '700 35px/1.1 Poppins,Helvetica,Arial,serif', color: 'white', margin: '0px' }}>
            Deliver with a Click
          </p>
        </ModalHeader>
        <ModalBody>
          <p class="featureListText text-align-left" style={{ font: '400 14px/1.33 Roboto,Helvetica,Arial,serif', color: '#030344' }}>One-Click Delivery: Once your ad is designed and ready, Adcropper Platform allows you to publish it to your preferred ad server or platform with just a single click. No need for downloading files or manually uploading them to external platforms—everything happens within the Platform’s dashboard.
          </p>
          <br />
          <p class="featureListText text-align-left" style={{ font: '400 14px/1.33 Roboto,Helvetica,Arial,serif', color: '#030344' }}>Seamless Integration: The Platform connects directly with major ad servers like Google Ads, Facebook Ads, and programmatic platforms, ensuring your ads are sent exactly where they need to go. This eliminates the need to export files and switch between multiple systems.
          </p>
          <br />
          <p class="featureListText text-align-left" style={{ font: '400 14px/1.33 Roboto,Helvetica,Arial,serif', color: '#030344' }}>Automated Format Adjustments: Adcropper Platform automatically formats your ads for the specific requirements of each platform. Whether it’s resizing for different display ad slots or adjusting specs for social media, the Platform takes care of these technical details.
          </p>
          <br />
          <p class="featureListText text-align-left" style={{ font: '400 14px/1.33 Roboto,Helvetica,Arial,serif', color: '#030344' }}>Real-Time Synchronization: Changes made to your ads can be instantly synced across connected platforms. If you need to tweak the design or copy, Adcropper Platfrom updates the live ad without the need for re-uploading, ensuring that the latest version is always in use.
          </p>
          <br />
          <p class="featureListText text-align-left" style={{ font: '400 14px/1.33 Roboto,Helvetica,Arial,serif', color: '#030344' }}>By offering direct integration with major ad platforms and streamlining the delivery process, Adcropper Platform saves time and ensures that your ads are live and running while reducing the possibility of errors during manual uploads.
          </p>
        </ModalBody>
      </Modal>

      {/* Measure */}
      <Modal isOpen={measureState} toggle={() => setMeasureState(false)}>
        <ModalHeader className='p-3' toggle={() => setMeasureState(false)}>
          <p style={{ font: '700 35px/1.1 Poppins,Helvetica,Arial,serif', color: 'white', margin: '0px' }}>
            Measure to Improve
          </p>
        </ModalHeader>
        <ModalBody>
          <p class="featureListText text-align-left" style={{ font: '400 14px/1.33 Roboto,Helvetica,Arial,serif', color: '#030344' }}>Centralized Performance Tracking: You can monitor key metrics such as impressions, clicks, and conversions all within the Adcropper platform, eliminating the need to jump between different analytics tools. This makes it easy to stay on top of how your ads are performing in real time.
          </p>
          <br />
          <p class="featureListText text-align-left" style={{ font: '400 14px/1.33 Roboto,Helvetica,Arial,serif', color: '#030344' }}>Data-Driven Optimization: By having access to precise data on campaign performance, you can identify what’s working and what’s not. This enables you to make informed decisions to adjust targeting, ad copy, or design elements to maximize effectiveness.
          </p>
          <br />
          <p class="featureListText text-align-left" style={{ font: '400 14px/1.33 Roboto,Helvetica,Arial,serif', color: '#030344' }}>Conversion Tracking: Adcropper tracks important actions taken by users, such as purchases or sign-ups, giving you a clear view of which ads are driving meaningful results. This helps you focus your budget on the highest-performing ads.
          </p>
          <br />
          <p class="featureListText text-align-left" style={{ font: '400 14px/1.33 Roboto,Helvetica,Arial,serif', color: '#030344' }}>Customisable Reports: You can generate customised reports to dive deep into specific metrics or compare the performance of different campaigns. This granular insight allows for a more thorough understanding of what improvements need to be made.
          </p>
          <br />
          <p class="featureListText text-align-left" style={{ font: '400 14px/1.33 Roboto,Helvetica,Arial,serif', color: '#030344' }}>Real-Time Feedback: With real-time performance data, you can make immediate adjustments to live campaigns, such as tweaking bids or creative elements, to quickly improve results without having to wait for traditional reporting delays.
          </p>
          <br />
          <p class="featureListText text-align-left" style={{ font: '400 14px/1.33 Roboto,Helvetica,Arial,serif', color: '#030344' }}>By directly offering comprehensive analytics, Adcropper Platform helps you continuously refine and optimise your campaigns, leading to better results and a higher return on investment.
          </p>
        </ModalBody>
      </Modal>
    </main>
  )
}

export default Features


